<template>
  <el-form @submit.native.prevent="creatBanner" :inline="true">
    <div>
      <el-card style="margin-top: 25px">
        <el-form-item label="banner标题">
          <el-input v-model="model.bannerName"></el-input>
        </el-form-item>
        <el-form-item label="banner描述">
          <el-input v-model="model.bannerDesc"></el-input>
        </el-form-item>
        <el-form-item label="banner技能">
          <el-input v-model="model.bannerSkill"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="model.bannerUrl"></el-input>
        </el-form-item>
        <el-form-item label="Banner所属分类">
          <el-select v-model="model.bannerID" placeholder="所属分类">
            <el-option
              v-for="item in bannerCate"
              :key="item.bannerID"
              :label="item.bannerType"
              :value="item.bannerID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="图片链接">
          <el-input v-model="item.bannerImg"></el-input>
        </el-form-item> -->
        <!-- 上传bammer图 -->
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/category/img/banner'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="bannerUpload"
        >
          <div v-show="showLeImg">
            <img style="width: 100%; height: 250px" :src="model.bannerImg" />
          </div>
          <el-button size="small" type="primary">点击上传详情图</el-button>
        </el-upload>
      </el-card>
    </div>

    <el-form-item style="margin-top: 25px">
      <el-button type="primary" native-type="submit">点击修改</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      showLeImg: true,
      model: {
        bannerID: "",
        bannerImg: "",
        bannerName: "",
        bannerDesc: "",
        bannerSkill: "",
        bannerUrl: "",
      },
      banner: [],
      bannerCate: [],
    };
  },
  methods: {
    async creatBanner() {
      try {
        const editbanner = await this.$http.put(
          "/banner/putedit?_id=" + `${this.id}`,
          this.model
        );
        if (editbanner.status === 201) {
          this.$message({
            type: "success",
            message: editbanner.data.msg,
          });
        }

        this.$router.push("/banner/list");
      } catch (error) {
        console.log(error);
      }
    },
    bannerUpload(res) {
      try {
        this.model.bannerImg = res;
        this.showLeImg = !this.showLeImg;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      //console.log(file);
    },

    handleRemove(uploadFile, uploadFiles) {
      console.log(uploadFile, uploadFiles);
    },
    async getEditBanner() {
      try {
        const getbanner = await this.$http.get("/banner/getedit", {
          params: { id: this.id },
        });
        console.log(this.$http.defaults.baseURL);
        this.model.bannerID = getbanner.data[0].bannerID;
        this.model.bannerName = getbanner.data[0].bannerName;
        this.model.bannerUrl = getbanner.data[0].bannerUrl;
        this.model.bannerSkill = getbanner.data[0].bannerSkill;
        this.model.bannerDesc = getbanner.data[0].bannerDesc;
        this.model.bannerImg = "/" + getbanner.data[0]?.bannerImg;

        //console.log(this.model);
      } catch (error) {
        console.log(error);
      }
    },
    async getBannerCate() {
      try {
        const result = await this.$http.get("/bannercate/getbannercate");
        this.bannerCate = result.data;
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.id && this.getEditBanner(this.id);
    this.getBannerCate();
  },
};
</script>

<style scoped></style>
